package ai.wagemix.net.models

import kotlinx.serialization.PolymorphicSerializer
import kotlinx.serialization.json.ClassDiscriminatorMode
import kotlinx.serialization.json.JsonBuilder
import kotlinx.serialization.modules.SerializersModule
import kotlinx.serialization.modules.polymorphic
import kotlinx.serialization.modules.subclass
import kotlinx.serialization.modules.plus

//private val wagemixSerializersModule: SerializersModule = SerializersModule {
//    polymorphic(WMIntegerChartData::class) {
//        subclass(
//            KxsWMIntegerChartData::class,
//            KxsWMIntegerChartData.serializer(
//                PolymorphicSerializer(Big)
//            )
//        )
//    }
//    polymorphic(WMBaseDataPointData::class) {
//        subclass(WMIntegerDataPointData::class)
//        subclass(WMFloatDataPointData::class)
//    }
//    polymorphic(WMIntegerDataPointData::class) {
//        subclass(KxsWMIntegerDataPointData::class)
//    }
//    polymorphic(WMFloatDataPointData::class) {
//        subclass(KxsWMFloatDataPointData::class)
//    }
//    polymorphic(WMDataSeriesData::class) {
//        subclass(WMIntegerDataSeriesData::class)
//        subclass(WMFloatDataSeriesData::class)
//        subclass(WMLabeledIntegerDataSeriesData::class)
//        subclass(WMLabeledFloatDataSeriesData::class)
//    }
//    polymorphic(WMIntegerDataSeriesData::class) {
//        subclass(KxsWMIntegerDataSeriesData::class)
//    }
//    polymorphic(WMFloatDataSeriesData::class) {
//        subclass(KxsWMFloatDataSeriesData::class)
//    }
//    polymorphic(WMLabeledIntegerDataSeriesData::class) {
//        subclass(KxsWMLabeledIntegerDataSeriesData::class)
//    }
//    polymorphic(WMLabeledFloatDataSeriesData::class) {
//        subclass(KxsWMLabeledFloatDataSeriesData::class)
//    }
//    polymorphic(WMLabeledDataPointData::class) {
//        subclass(WMLabeledIntegerDataPointData::class)
//        subclass(WMLabeledFloatDataPointData::class)
//    }
//    polymorphic(WMLabeledIntegerDataPointData::class) {
//        subclass(KxsWMLabeledIntegerDataPointData::class)
//    }
//    polymorphic(WMLabeledFloatDataPointData::class) {
//        subclass(KxsWMLabeledFloatDataPointData::class)
//    }
//}

fun JsonBuilder.configureWagemix() {
//    serializersModule = serializersModule + wagemixSerializersModule
    ignoreUnknownKeys = true

    classDiscriminatorMode = ClassDiscriminatorMode.ALL_JSON_OBJECTS
}
